export default "__VITE_ASSET__D2JHr4VK__"